import React from "react";

export interface TagSelectorOption {
  label: string;
  value: any;
}

export interface TagSelectorProps {
  options: TagSelectorOption[];
  value: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
  allowClear?: boolean; // 是否允许取消选中
}

/**
 * TagSelector 标签选择器组件
 * 渲染一组可点击的标签，支持单选功能
 * @param options 选项列表
 * @param value 当前选中值
 * @param onChange 值改变回调
 * @param disabled 是否禁用
 * @param allowClear 是否允许取消选中（默认 true）
 */
export const TagSelector: React.FC<TagSelectorProps> = ({
  options,
  value,
  onChange,
  disabled = false,
  allowClear = true,
}) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
      {options.map((opt) => {
        const isSelected = value === opt.value;
        return (
          <div
            key={opt.value}
            onClick={() => {
              if (disabled) return;
              // 如果不允许取消选中，且当前项已选中，则不做任何操作
              if (!allowClear && isSelected) return;
              if (onChange) {
                onChange(isSelected ? null : opt.value);
              }
            }}
            style={{
              border: `1px solid ${isSelected ? "var(--theme-primary)" : "#CBD5E1"}`,
              borderRadius: "6px",
              padding: "0 16px",
              cursor: disabled ? "not-allowed" : "pointer",
              backgroundColor: isSelected ? "var(--theme-tertiary)" : "#fff",
              color: isSelected ? "var(--theme-primary)" : "#334255",
              fontSize: 16,
              fontWeight: 400,
              minWidth: 80,
              transition: "all 0.3s",
              userSelect: "none",
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {opt.label}
          </div>
        );
      })}
    </div>
  );
};
